<template>
  <div>
    <!-- <div class="footer">copyright © 鲁ICP备2021028667号 版权所有：济南台菱自动化科技有限公司 rights reserved.</div> -->
    <div class="footer">copyright © 版权所有：华控（山东）技术有限公司 rights reserved.</div>
  </div>
</template>

<script>
export default {
  name: 'ValidCode',
  data() {
    return {
    }
  },
  mounted() {
  },
  methods: {
  }
}
</script>

<style scoped lang="scss">
.footer {
  width: 100%;
  height: 84px;
  background: #333333;
  text-align: center;
  line-height: 84px;
  font-size: 18px;
  font-family: ArialMT;
  color: #FFFFFF;
}
</style>


// WEBPACK FOOTER //
// src/components/footer.vue